<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router/composables'
import { ref } from 'vue'
import { useLoadingStore, useToastStore, useUserStore } from '@/stores'
import { api } from '@/api'
import { $formatErrorMessage } from '@/helpers'

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()
const userStore = useUserStore()

const router = useRouter()
const route = useRoute()
const redirectUrl = ref(route.query.r as string || 'home');

const name = ref('')

async function onSubmit() {
  if (!name.value.trim()) {
    $toast('请输入姓名')
    return
  }
  try {
    $showLoading()
    await api.post('/escort/user/update_name', {
      name: name.value.trim(),
    })
    // 同步更新本地用户信息
    userStore.$state.name = name.value.trim()
    $toast('更新成功')
    if (redirectUrl.value !== 'home') {
      redirectUrl.value = redirectUrl.value.replace('%2F', '')
    }
    if (!redirectUrl.value) {
      redirectUrl.value = 'home'
    }
    router.replace({ name: redirectUrl.value })
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
  finally {
    $hideLoading()
  }
}
</script>

<template>
  <div class="min-h-screen px-5 py-10 bg-gradient-to-br from-blue-400 to-blue-100">
    <p class="py-20 text-2xl font-bold text-center">
      请输入您的姓名
    </p>

    <div class="mt-4 rounded-full overflow-hidden shadow">
      <input v-model="name" type="text" class="w-full h-10 px-4" placeholder="请输入姓名" @keyup.enter="onSubmit">
    </div>

    <button
      class="mt-4 w-full h-10 lh-10 text-white bg-#467FF2 rounded-full"
      @click="onSubmit"
    >
      确认提交
    </button>
  </div>
</template>
